// assets
import {
  ClusterOutlined,
  ControlOutlined,
  LineChartOutlined,
  MailOutlined,
  PlusOutlined,
  SettingOutlined,
  TagsOutlined
} from '@ant-design/icons';
import RubleCircleOutlined from 'components/icons/RubleCircleOutlined';

import { isUiHidden } from 'config/hiddenUi';

// icons
const icons = {
  ClusterOutlined,
  ControlOutlined,
  LineChartOutlined,
  MailOutlined,
  RubleCircleOutlined,
  PlusOutlined,
  SettingOutlined,
  TagsOutlined
};

// ==============================|| MENU ITEMS - PROJECTS ||============================== //

const projectMenuChildrenAll = [
  {
    id: 'projects-list',
    title: 'Список проектов',
    type: 'item',
    url: '/clones',
    icon: icons.ClusterOutlined,
    breadcrumbs: false
  },
  {
    id: 'projects-create',
    title: 'Создать проект',
    type: 'item',
    url: '/clones/create',
    icon: icons.PlusOutlined,
    breadcrumbs: false
  },
  {
    id: 'generation-analytics',
    title: 'Аналитика генерации',
    type: 'item',
    url: '/generation-analytics',
    icon: icons.LineChartOutlined,
    breadcrumbs: false
  },
  {
    id: 'scheduler-ml',
    title: 'Scheduler ML',
    type: 'item',
    url: '/scheduler-ml',
    icon: icons.LineChartOutlined,
    breadcrumbs: false
  },
  {
    id: 'generation-queue-priorities',
    title: 'Приоритеты генерации',
    type: 'item',
    url: '/generation-queue-priorities',
    icon: icons.ControlOutlined,
    breadcrumbs: false
  },
  {
    id: 'tariffs-management',
    title: 'Тарифы',
    type: 'item',
    url: '/tariffs',
    icon: icons.RubleCircleOutlined,
    breadcrumbs: false
  },
  {
    id: 'notifications-list',
    title: 'Уведомления',
    type: 'item',
    url: '/notifications',
    icon: icons.MailOutlined,
    breadcrumbs: false
  },
  {
    id: 'email-previews',
    title: 'Макеты писем',
    type: 'item',
    url: '/email-previews',
    icon: icons.MailOutlined,
    breadcrumbs: false
  },
  {
    id: 'billing-events-list',
    title: 'События биллинга',
    type: 'item',
    url: '/billing-events',
    icon: icons.ControlOutlined,
    breadcrumbs: false
  },
  {
    id: 'payments-list',
    title: 'Платежи',
    type: 'item',
    url: '/payments',
    icon: icons.RubleCircleOutlined,
    breadcrumbs: false
  },
  {
    id: 'modules-management',
    title: 'Управление модулями',
    type: 'item',
    url: '/modules',
    icon: icons.SettingOutlined,
    breadcrumbs: false
  },
  {
    id: 'attributes-management',
    title: 'Управление атрибутами',
    type: 'item',
    url: '/attributes',
    icon: icons.TagsOutlined,
    breadcrumbs: false
  }
];

const projects = {
  id: 'group-projects',
  title: 'Управление проектами',
  type: 'group',
  children: projectMenuChildrenAll.filter((item) => {
    if (item.id === 'modules-management' && isUiHidden('modules')) return false;
    if (item.id === 'attributes-management' && isUiHidden('attributes')) return false;
    return true;
  })
};

export default projects;
